import classNames from 'classnames';
import React, { useMemo } from 'react';

import { useTypedSelector } from '@/store';

import styles from './index.module.less';

interface IProps {
  onChange: (val: Record<string, string[]>) => void;
  value: Record<string, string[]>;
}

const TagChoose: React.FC<IProps> = ({ onChange, value }) => {
  const { category = '' } = useTypedSelector(store => store.tag)
    .find((e: any) => e.type === 'haimian')
    || { category: '' };

  const tags: Array<{
    name: string;
    value: string;
    list: Array<{ name: string; value: string }>;
  }> = useMemo(() => {
    try {
      return JSON.parse(category) || [];
    } catch {
      return [];
    }
  }, [category]);

  const clickTag = (categoryValue: string, tagValue: string) => {
    const currentTags = value?.[categoryValue] || [];
    const newTags = currentTags.includes(tagValue) ? [] : [tagValue];
    onChange({ ...value, [categoryValue]: newTags });
  };

  return (
    <div className={styles.wrapper}>
      {tags.map(e => (
        <div key={e.value} className={styles.categoryRow}>
          <div className={styles.name}>{e.name}</div>
          <div className={styles.wordsList}>
            {e.list.map((tag, index) => (
              <div
                key={index}
                className={classNames(
                  styles.word,
                  { [styles.selected]: (value?.[e.value] || []).includes(tag.value) },
                )}
                onClick={() => clickTag(e.value, tag.value)}
              >
                {tag.name}
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default TagChoose;
